import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  }
};

// NOTE: Multi-language support planned for v1.1
// Currently locked to German (DE) for Go-Live 1.0
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Force German
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;